import React, { useState } from 'react';

import MapSlider from './MapSlider';
import Spreader from '../Spreader';
import Legend from './Legend';
import Appearance from '../Appearance';

import Anchor, { SECTIONS } from '../Anchor';

import Banner, { DIRECTIONS } from '../Banner';

import './styles.css';

export default props => {
  return (
    <div className="History">
      <Spreader>
        <Banner
          direction={DIRECTIONS.RIGHT}
          style={{ top: '-50px' }}
          title="Из поколения в поколение"
        >
          Как эволюционировали телекоммуникации в России за последние 30 лет
        </Banner>
      </Spreader>
      <Appearance type="up">
        <Legend className="History__slider" />
      </Appearance>
      <Spreader>
        <Banner direction={DIRECTIONS.LEFT} style={{ marginBottom: '40px' }}>
          <div className="History__banner-title">
            Из Санкт-Петербурга – на всю страну
          </div>
          Развитие связи в РФ на примере сети МегаФона в Северо-Западном
          федеральном округе, где компания в 1993 году начала свой путь от
          небольшого регионального оператора к одному из крупнейших в Европе
        </Banner>
      </Spreader>
      <Anchor section={SECTIONS.HISTORY_MAP} />
      <MapSlider />
      <Spreader>
        <Appearance type="up">
          <div className="History__stat">
            Чем больше у сотового оператора базовых станций, тем шире покрытие
            сети, тем качественнее и стабильнее связь. МегаФон почти три года
            удерживает лидерство в России как по общему числу базовых станций,
            так и по количеству базовых станций стандарта 4G. Базовые станции
            МегаФона:
            <ul>
              <li>2G (GSM) – 80 027</li>
              <li>3G – 59 400</li>
              <li>4G (LTE) – 105 296</li>
            </ul>
            Всего: 244 723 (#1 в России)
            <br />
            Источник статистики – Роскомнадзор
            <br />
            <br />
          </div>
        </Appearance>
      </Spreader>
    </div>
  );
};
